import { lazy, Suspense, type ReactElement } from 'react';
import type { RouteObject } from 'react-router-dom';
import { RouteFallback } from '@/components/shared/RouteFallback';

// BUG-001 (BUGS.md) — route-based code splitting: har bir sahifa alohida chunk.
const ForbiddenPage = lazy(() => import('./pages/ForbiddenPage').then((m) => ({ default: m.ForbiddenPage })));
const SessionExpiredPage = lazy(() =>
  import('./pages/SessionExpiredPage').then((m) => ({ default: m.SessionExpiredPage })),
);
const OfflinePage = lazy(() => import('./pages/OfflinePage').then((m) => ({ default: m.OfflinePage })));
const ServerErrorPage = lazy(() => import('./pages/ServerErrorPage').then((m) => ({ default: m.ServerErrorPage })));

function withFallback(element: ReactElement): ReactElement {
  return <Suspense fallback={<RouteFallback />}>{element}</Suspense>;
}

// ⚠️ Catch-all "*" (404) BU YERDA EMAS — router/registry.ts glob tartibi alifbo bo'yicha
// bo'lgani uchun "*" boshqa domen route'laridan oldin kelib qolishi mumkin (masalan "manager"
// "errors" dan keyin keladi). 404 App.tsx da featureRoutes'dan KEYIN qo'lda qo'shiladi.
export const routes: RouteObject[] = [
  { path: '/403', element: withFallback(<ForbiddenPage />) },
  { path: '/session-expired', element: withFallback(<SessionExpiredPage />) },
  { path: '/offline', element: withFallback(<OfflinePage />) },
  { path: '/500', element: withFallback(<ServerErrorPage />) },
];
